import { isProductSubmission, isValueEmpty } from '../utils';
export function arrayEquals(givenValue, expectedValue) {
    if (isValueEmpty(givenValue)) {
        return false;
    }
    if (!Array.isArray(givenValue) || !Array.isArray(expectedValue)) {
        throw new Error(`All operator: Unsupported values to compare ${JSON.stringify(givenValue)}, ${JSON.stringify(expectedValue)}`);
    }
    if (givenValue.length !== expectedValue.length) {
        return false;
    }
    if (isProductSubmission(givenValue)) {
        return equals(givenValue.map((product) => product.productId), expectedValue);
    }
    return equals(givenValue, expectedValue);
}
function equals(givenValue, expectedValue) {
    return expectedValue.every((v) => givenValue.includes(v));
}
//# sourceMappingURL=arrayEquals.js.map